module.exports = __webpack_public_path__ + "static/media/house3.a3f4eb86.jpeg";